import React,{Component} from 'react';
import {withTranslation} from 'react-i18next';
import { callGET,callPOST,callDELETE } from '../../../Utils/ApiUtil';
import BreadCrumbs from "../../../Components/UI/BreadCrumbs";
import Wrp from "../../../hoc/Wrp/Wrp";
import TableRecord from "../../../Components/UI/TableRecord";
import * as ShipConstants from '../../../Global/Constants';
import { deleteViolationsMsg, isSet, stringHasText } from '../../../Utils/CommonFunctions';
import CreateNew from './CreateNew';
import { getCurrentModuleId } from '../../../Utils/UserFunctions';
import { LinkContainer } from 'react-router-bootstrap';

class ExcelList extends Component {

	state = {
		breadCrumbs:this.props.breadCrumbs,
		isCreateExcelModalOpen:false,
    isVariableTemplate:true,
		excelDetails:{
			active:false,
			isDefault:false,
			description:'',
			excel_template_fields:[],
			name:'',
			profile_id:'',
			users:[],
			shared:false,
			layout_id:'',
      is_window:false,
      window_id:"",
      layoutName:""
		},
    windowList:[],
		profileList:[],
		usersList:[],
    layoutList:[],
		violations:null,
    tableRecords:{
      tableHead:[
        {
          name:"Action",
          type:"Actions",
          href:"",
          isShow:true,
          clickHandler:"",
          attributes:{
            style:{width: "75px"}
          }
        },
        {
          name:"Template Name",
          type:"Setting",
          clickHandler:"",
          isShow:true,
          attributes:{
          }
        },
        {
          name:"Is Shared",
          type:"Status",
          isShow:true,
          clickHandler:"",
        },
        {
          name:"Window",
          type:"HyperLink",
          isShow:true,
          clickHandler:"",
        },
        {
          name:"Layout",
          type:"HyperLink",
          isShow:true,
          clickHandler:"",
        },
        {
          name:"Profile",
          type:"Button List",
          isShow:true,
          clickHandler:"",
        },
        {
          name:"Is Default",
          type:"Status",
          isShow:true,
          clickHandler:"",
        },
        {
          name:"Is Active",
          type:"Status",
          isShow:true,
          clickHandler:"",
        },
      ],
      tableData:[], 
      pagination:{
        page:0,
        orderBy:'',
        perPage:10,
        direction:'ASC',
        totalRecords:0,
        search:''
      }
    }
  }

  componentWillMount() {
  	this.excelTemplateList(this.state.tableRecords.pagination);
  	this.profileList();
    this.windowsList();
  	this.setState({
      breadCrumbs: {
          backHistory : [{
          href : "/settings",
          name:"Settings"
          }],
          pageTitle:"Excel Template List",
          buttonList:[
          {
              clickHandler:this.toggleCreateExcelModel,
              attributes:{
                className:"btn primary_bg"
              },
              name:"Add New",
              type:"addNew",
          }
          ]
      }
    });
  }

  toggleTab = (type) => {
    this.setState({
      isVariableTemplate:type,
      tableRecords:{
        ...this.state.tableRecords,
        pagination:{
          page:0,
          orderBy:'',
          perPage:10,
          direction:'ASC',
          totalRecords:0,
          search:''
        }
      }
    })
    setTimeout(() => {
      this.excelTemplateList(this.state.tableRecords.pagination);
    }, 300); 
  }

  render() {
		// console.log(this.state);
		return (
		<Wrp>
			<BreadCrumbs breadCrumbsList={this.state.breadCrumbs} />
      <ul className="nav nav-pills navcrm-primary nav-pills-no-bd fixed-2" role="tablist">
        <li className="nav-item"> <a onClick={e=>this.toggleTab(true)} className={this.state.isVariableTemplate === true ? "nav-link active show" : "nav-link show" } data-toggle="tab" href="#variableTemplate" role="tab" aria-selected="true">Variable Template</a> 
        </li>
        <li className="nav-item"> <a onClick={e=>this.toggleTab(false)} className={this.state.isVariableTemplate !== true ? "nav-link active show" : "nav-link show" } data-toggle="tab" href="#windowTemplate" role="tab" aria-selected="false">Window Template</a> 
        </li> 
      </ul>
			<div className="viewport">
        <div className="view view-xl">
        
          <div className="outerPort">
              <TableRecord 
                tableRecords={this.state.tableRecords} 
                recordsChangeHandler={this.excelTemplateList}
              />
            </div>   
        </div>
      </div> 
      <CreateNew
      	isCreateExcelModalOpen={this.state.isCreateExcelModalOpen}
        toggleCreateExcelModel={this.toggleCreateExcelModel}
        saveExcelHandler={this.saveExcelHandler}
        basicInfoChangeHandler={this.basicInfoChangeHandler}
        valueChangeHandlerWithName={this.valueChangeHandlerWithName}
        profileList={this.state.profileList}
        usersList={this.state.usersList}
        excelDetails={this.state.excelDetails}
        violations={this.state.violations}
        windowList={this.state.windowList}
        layoutList={this.state.layoutList}
      />
    </Wrp>
		)
	}

	toggleCreateExcelModel = () => {
		this.setState({
			isCreateExcelModalOpen:!this.state.isCreateExcelModalOpen,
			excelDetails:{
				active:false,
				isDefault:false,
				description:'',
				excel_template_fields:[],
				name:'',
				profile_id:'',
				users:[],
				shared:false,
				layout_id:''
			}
		});
	}

	excelTemplateList = (pagination) => {
    const page = pagination.page; 
    const orderBy = pagination.orderBy; 
    const perPage = pagination.perPage; 
    const direction = pagination.direction; 
    const search = pagination.search;
    this.setState({
      tableRecords:{
        ...this.state.tableRecords,
        pagination:pagination
      }
    })
    const body = {variable_mapping:this.state.isVariableTemplate};
    const queryString = '?search='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
    this.props.Loader(true);
    callPOST("excel/templates/paginated-search/"+queryString,body)
    .then(res => {
	  this.props.Loader(false);
      const response = res.data;
      if(response.code===ShipConstants.API_STATUS_SUCCESS){
        let updateTableData = response.data.content.map((item,index)=>{
            let buttonItems = [];
            if(item.user_ids!==null && item.user_ids!==undefined){                
              item.user_ids.map((user, ii)=>{
                buttonItems.push({
                  value: user,
                  href:"/permission-controls/profiles/"+user,
                  attributes:{
                    className:"text-info textUnderline mr-2",
                    id: user,
                  },
                 access_mode:true
                })
              })                 
            }
            return {
              className:'icon_hover cursor-pointer',
              rowId:"",
              data:{
                actions:[
                  {
                  clickHandler:this.editHandler.bind(this,item),
                  attributes:{
                    className:"p-1"
                  },
                  svgIcon:"Edit",
                  name:""
                },
                  {
                    attributes:{
                      className:"p-1"
                    },
                    svgIcon:"Delete",
                    clickHandler:this.deleteFileSetup.bind(this,item.id),
                    name:""
                  }
                  
              ],
                file_name:{
                  value:item.name,
                  href:"/excel-template/"+item.id,
                  param:{
                    data:{...item},
                  },
                  attributes:{},
                  setting:{}
                },
                share_template:{
                  checked:item.shared,
                  attributes:{}
                },
                window:{
                  value:isSet(item.window_name,'--'),
                  attributes:{},
                  setting:{}
                },
                layout:{
                  value:isSet(item.layout_name,'--'),
                  attributes:{},
                  setting:{}
                },
                profile:[{
                  value: isSet(item.profile_name,'--'),
                  href:"/permission-controls/profiles/"+item.profile_id,
                  attributes:{
                    className:"text-info textUnderline mr-2",
                    id: item.profile_name,
                  },
                 access_mode:true
                }],
                default:{
                  checked:item.default,
                  attributes:{}
                },
                status:{
                  checked:item.active,
                  attributes:{}
                },
                
              }
            }
              
        });
        const totalRecords = response.data.total_elements;
        this.setState({status:200, tableRecords:{
          tableData:{data:updateTableData,status:200},
          tableHead:this.state.tableRecords.tableHead ,
          pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
        }});
      }else{
        const totalRecords = 0;//response.data.totalElements;
        this.setState({status:200, tableRecords:{
          tableData:[],
          tableHead:this.state.tableRecords.tableHead ,
          pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
        }});
      }
    }, (error) => {
      this.props.Loader(false);
    })
  }

  deleteFileSetup = (id) => {
  	// let isDelete = window.confirm("are you sure you want to delete this data?");
		// if(isDelete) {
			this.props.Loader();
			callDELETE("excel/template/delete",[id])
			.then(response => {
				this.props.Loader(false);
				const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          this.props.succMessage(responseData.message);
          this.excelTemplateList(this.state.tableRecords.pagination);
        }else {
          this.props.failMessage(responseData.message);
        }
			}, (error) => {
	      this.props.Loader(false);
	      this.props.failMessage('Error occured!');
	    })
		// }
  }

  profileList = () => {
  	callGET("profiles/view")
	    .then(res => {
	      const response = res.data;
	      if(response.code===ShipConstants.API_STATUS_SUCCESS){
	      	if(response.data.content && response.data.content.length > 0) {
	      		this.setState({profileList:response.data.content});
	      	}
	      }
	    }, (error) => {
	      this.props.failMessage("Error occured : Fetching layout list");
	    })
  }	

	usersList = (profileId) => {
		this.props.Loader();
    callGET("profiles/allotted-users/"+profileId)
    .then(res => {
      const response = res.data;
      if(response.code===ShipConstants.API_STATUS_SUCCESS){
      	let usersList = [];
      	if(response.data.content) {
      		response.data.content.map(arr => {
      			let name = arr.first_name+" "+arr.last_name;
      			let value = {
              label:name,
              text:name,
              value:arr.id,
              id:arr.id
            }
      			usersList.push(value)
      		})
      	}
      	this.setState({usersList:usersList});
      	this.props.Loader();
      }else{
        this.props.Loader();
        this.props.failMessage(response?.message);
      }
    }, (error) => {
    	this.props.Loader();
      this.props.failMessage("Error occured : Fetching layout list");
    })
  }	  

	basicInfoChangeHandler = (e) => {
		const {name,value,checked} = e.target;
		const updateState = {...this.state};
    if(name === "window_id") {
      updateState.excelDetails[name]=value;
      this.layoutList(value);
    }else if(name === 'isDefault' || name === 'active' || name === 'is_window') {
			updateState.excelDetails[name]=checked;
		}else if(name === 'shared') {
			updateState.excelDetails[name]=checked;
			updateState.excelDetails['profile_id']='';
			updateState.excelDetails['users']=[];
		}else {
			updateState.excelDetails[name]=value;
		}
		if(this.state.violations) {
			let viol = deleteViolationsMsg(name,this.state.violations);
			updateState.violations = viol;
		}
		this.setState(updateState);

		if(name === 'profile_id') {
			this.usersList(value);
		}
	}

	valueChangeHandlerWithName = (name,value) => {
  	const updateState = {...this.state};
  	updateState.excelDetails[name] = value;
  	this.setState(updateState);
  }

  saveExcelHandler = (isSaveAndNew=false) => {
  	let data = this.state.excelDetails;
  	let userIds = [];
  	if(data.users && Array.isArray(data.users)) {
  		data.users.map(item => {
  			userIds.push(item.value);
  		})
  	}
  	data.user_ids = userIds;
  	data.default = data.isDefault;
  	data.module_id= getCurrentModuleId();
    data.variable_mapping=!data.is_window;
  	// console.log(JSON.stringify(data));
  	this.props.Loader();
  	callPOST("excel/template/save",data)
	    .then(response => {
	    	this.props.Loader();
	      const responseData = response.data;
	      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	      	if(responseData.data) {
	      		this.toggleCreateExcelModel();
	      		this.excelTemplateList(this.state.tableRecords.pagination);
	      	}
	        this.props.succMessage(responseData.message);
	      }else {
	      	let viol = {};
	      	let errMsg = '';
	      	if(responseData.violations && responseData.violations.length > 0) {
	      		let isTmeplateEmpty = false;
	      		responseData.violations.map((arr,ind) => {
	      			if(arr.field_name === 'excel_template_fields') {
	      				isTmeplateEmpty = true;
	      			}else {
	      				const data = arr.field_name+':'+arr.message;
		      			const key = arr['field_name'].replace(/['"]+/g, '');
		      			viol[key]= arr['message'];
		      			errMsg += ind === 0 ? data : ', '+data;
	      			}
	      		})
	      		if(isTmeplateEmpty === true && Object.keys(viol).length === 0) {
	      			this.props.failMessage("Excel Template Field is empty");
	      		}
	      		this.setState({violations:viol});
	      	}else {
		      	this.props.failMessage(responseData.message+"<br/>"+errMsg);
	      	}
	      }
    	})
	    .catch(err => {
	      this.props.Loader();
	      this.props.failMessage("Error occured");
	      console.log(err);
	    })
  }

  editHandler = (data) => {
  	console.log('editHandler',data);
  	const updateState = {...this.state};
    updateState.excelDetails['id'] = data['id'];
    updateState.excelDetails['active'] = data['active'];
    updateState.excelDetails['isDefault'] = data['default'];
    updateState.excelDetails['description'] = data['description'];
    updateState.excelDetails['name'] = data['name'];
    updateState.excelDetails['profile_id'] = data['profile_id'];
    updateState.excelDetails['shared'] = data['shared'];
    updateState.excelDetails['is_window'] = !data['variable_mapping'];
    updateState.excelDetails['window_id'] = data['window_id'];
    updateState.excelDetails['layoutName'] = data['layout_name'];

    let users = [];
		if(data.user_names) {
			Object.keys(data.user_names).forEach(function(key) {
			    users.push({id:key,label:data.user_names[key],text:data.user_names[key],value:key});
			});
		}
		updateState.excelDetails['users'] = users;

    updateState.isCreateExcelModalOpen = true;
    this.setState(updateState)
  }

  windowsList = () => {
    const page = 0;//pagination.page; 
    // const orderBy = pagination.orderBy; 
    // const perPage = pagination.perPage; 
    const direction = '';//pagination.direction; 
    const search = '';//pagination.search;
    const {match} = this.props;
    const {params} = match;
    console.log('params',params);
    const queryString = '?query='+search+'&page='+page+'&orderBy=display_name&size=10000000&direction='+direction;
      callGET("windows/list/true/true"+queryString)
      .then(res => {
          const response = res.data;
          let windowsList = [];
          if(response.code===200){
            response.data.windows.content.map((arr,i) => {
                const value = {
                "label": arr.display_name,    
                "name": arr.display_name,
                "value": arr.id,
                }
                windowsList.push(value);
            })
          }
          this.setState({windowList:windowsList});
          
      }, (error) => {
          console.log(error);
      });
  }

  //Window Layout List 
  layoutList = (windowId) => {
      const page = 0;//pagination.page; 
      const orderBy = '';//pagination.orderBy; 
      const perPage = 100;//pagination.perPage; 
      const direction = '';//pagination.direction; 
      const search = '';//pagination.search;

      let layoutList = [{value:'',name:'-None-',label:'-None-'}];
      const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
      callGET("layouts/window/master-layout/"+windowId+"/true"+queryString)
      .then(res => {
        if(res.status===200){ 
          const response = res.data;
          if(response.code===200){
            response.data.content.map((item)=>{
              layoutList.push({
                  value:item.id,
                  name:item.layout_name,
                  label:item.layout_name
              })
            });
            this.setState({
              layoutList:layoutList
            });
          }
        }
      }, (error) => {
          this.setState({
              layoutList:[]
            });
          this.props.failMessage("Layout list fetch went wrong..");
      })
  }  
}

export default withTranslation()(ExcelList);